import smartPay from '../../../../../assets/icons/smart-pay.svg'

export const SmartPayLogo = ({ onClick }: { onClick?: () => void }) => (
    <img src={smartPay} onClick={() => onClick?.()} />
)
